var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.setShow) ? _c('div', {
    staticClass: "dashboard-text"
  }, [_vm._v("OA设置")]) : _vm._e(), _vm._v(" "), (!_vm.setShow) ? _c('div', {
    staticClass: "dashboard-content"
  }, [_c('el-form', {
    staticStyle: {
      "position": "relative",
      "padding": "40px 0 0 46px"
    },
    attrs: {
      "inline": true,
      "model": _vm.condition
    }
  }, [_c('div', [_c('el-form-item', {
    staticClass: "items",
    attrs: {
      "label": "审批流名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入审批流名称",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.approval_process_name),
      callback: function($$v) {
        _vm.$set(_vm.condition, "approval_process_name", $$v)
      },
      expression: "condition.approval_process_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "items",
    attrs: {
      "label": "类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "203px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.condition.approval_process_type),
      callback: function($$v) {
        _vm.$set(_vm.condition, "approval_process_type", $$v)
      },
      expression: "condition.approval_process_type"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "items",
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "203px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.state),
      callback: function($$v) {
        _vm.$set(_vm.condition, "state", $$v)
      },
      expression: "condition.state"
    }
  }, _vm._l((_vm.roleList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "dashboard-button",
    on: {
      "click": function($event) {
        return _vm.Find()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "dashboard-button",
    on: {
      "click": function($event) {
        return _vm.clickBtn('DEL-ALL')
      }
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "dashboard-buttonWhite",
    on: {
      "click": function($event) {
        return _vm.clickBtn('ADD')
      }
    }
  }, [_vm._v("新增")])], 1)], 1)]), _vm._v(" "), _c('section', [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tableBox",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "580",
      "data": _vm.tableData,
      "header-cell-style": {
        'text-align': 'center',
        background: '#F0F0F0',
        color: '#000'
      },
      "cell-style": {
        'text-align': 'center'
      }
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审批流名称",
      "prop": "approval_process_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "prop": "type_title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "state"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 1) ? _c('span', {
          staticClass: "green"
        }, [_vm._v("启用")]) : _vm._e(), _vm._v(" "), (scope.row.state == 0) ? _c('span', {
          staticClass: "red"
        }, [_vm._v("停用")]) : _vm._e()]
      }
    }], null, false, 2012449674)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "dashboard-delDisplay"
        }, [(scope.row.state == '0') ? _c('img', {
          attrs: {
            "src": require("../../../assets/oa/operate-using.png"),
            "alt": ""
          },
          on: {
            "click": function($event) {
              return _vm.clickBtn('operateusing', scope.row.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.state == '1') ? _c('img', {
          attrs: {
            "src": require("../../../assets/oa/operate-deactivate.png"),
            "alt": ""
          },
          on: {
            "click": function($event) {
              return _vm.clickBtn('operatedeactivate', scope.row.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('img', {
          staticStyle: {
            "margin": "0 10px"
          },
          attrs: {
            "src": require("../../../assets/oa/operate-edit.png"),
            "alt": ""
          },
          on: {
            "click": function($event) {
              return _vm.clickBtn('edit', scope.row)
            }
          }
        })])]
      }
    }], null, false, 3447895051)
  })], 1)], 1), _vm._v(" "), _c('section', {
    staticStyle: {
      "text-align": "center",
      "padding": "20px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.condition.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.setShow) ? _c('setAddPage', {
    ref: "add",
    attrs: {
      "List": _vm.List,
      "num": _vm.num
    },
    on: {
      "closeBack": _vm.closeBack
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d779dcf6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oa/set/set.vue
// module id = null
// module chunks = 